import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PrimaryDialog } from "../PrimaryDialog";
import styles from "../PasswordDialog/PasswordDialog.module.scss";
import { MainInputInput } from "../MainInput";
import { Button } from "../Button";
import { apiClient } from "../../../services/api";

export default function ResetPasswordForm() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState('');
  const [ok, setOk] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setError('');
    try {
      await apiClient.post('/users/reset-password', { password, token });
      setOk(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      setError(e.response?.data?.message || 'Error');
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError('');
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (error) setError('');
  }

  if (ok) return <div>Password changed! Redirecting to login...</div>;

  return (
    <PrimaryDialog
      mode="dark"
      size="sm"
      radius="radius-16"
      blurBackdrop
      open={true}
      className={styles.dialogContainer}
    >
      <div>
        <h2>Set new password</h2>
        <MainInputInput
          placeholder="New password"
          type="password"
          value={password}
          onEnter={handleSubmit}
          onChange={handlePasswordChange}
          error={!!error}
          helperText={error ? error : ''}
        />
        <MainInputInput
          placeholder="Confirm new password"
          type="password"
          value={confirmPassword}
          onEnter={handleSubmit}
          onChange={handleConfirmPasswordChange}
          error={!!error}
          helperText={error ? error : ''}
        />
        <Button className={styles.submitBtn} onClick={handleSubmit}>Change password</Button>
      </div>
    </PrimaryDialog>
  )
}
